// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3p8lF","select":"Header_select__301LP","clinic":"Header_clinic__k2BgE"};